<template>
  <div class="main-box">
    <div class="filter-box">
      <el-form inline>
        <el-form-item label="角色名称:">
          <el-input type="text" v-model="searchData.roleName" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色创建人:">
          <el-select v-model="searchData.userId" placeholder="请选择角色创建人">
            <el-option v-for="item in userOption" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="button-box">
          <el-button size="small" @click="reset()">重置</el-button>
          <el-button size="small" type="primary" @click="getTableData()">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="tool-box">
      <el-button size="small" @click="addRoleDialog = true" btn-id='27' v-btn-set>新建角色</el-button>
      <el-button size="small" type="primary" btn-id='28' @click="setUp(true)" v-btn-set>所有权限</el-button>
    </div>

    <div class="table-box">
      <el-table :data="tableData" height="440" style="width: 100%" header-row-class-name="tableHeader"
        row-class-name='tableRowClass'>
        <el-table-column prop="roleName" label="角色名称" align="center"></el-table-column>
        <el-table-column prop="createName" label="创建人" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column prop="remark" label="角色描述" align="center"></el-table-column>
        <el-table-column label="操作" width="500" align="center" header-align="center">
          <template slot-scope="scope">
            <el-button type="text" btn-id='29' v-btn-set @click="checkAccount(scope.row)">已授权账号</el-button>
            <el-button type="text" btn-id='30' v-btn-set @click="setUp(true,scope.row)">权限查看</el-button>
            <el-button type="text" btn-id='31' v-btn-set @click="setUp(false,scope.row)">权限设置</el-button>
            <el-button round @click="editFun(scope.row)" btn-id='32' v-btn-set>编辑</el-button>
            <el-button type="primary" round @click="deleteFun(scope.row)" btn-id='33' v-btn-set>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :page="searchData.pageNum" :limit="searchData.pageSize" :total="total" @pagination="otherPage">
      </pagination>
    </div>

    <!-- 新建/编辑角色 -->
    <el-dialog
      :title="editType ? '编辑角色':'新建角色'"
      :visible.sync="addRoleDialog"
      width="5rem"
      center>
      <div class="dialog-contant">
        <el-form :model="addRoleForm" ref="addRoleForm" :rules="addRoleRule" label-width="1rem">
          <el-form-item prop="roleName" label="角色名称">
            <el-input v-model="addRoleForm.roleName" type="text" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item prop="remark" label="角色描述">
            <el-input  v-model="addRoleForm.remark" type="text" placeholder="请输入角色描述"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addRoleDialog = false">取 消</el-button>
        <el-button type="primary" @click="addFun()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import pagination from '@/components/pagination'
  import * as roleManagementSerice from '@/api/systemManagement/roleManagement'
  import {
    getAllMenu
  } from '@/api/common'
  export default {
    name: 'RoleList',
    components: {
      pagination,
    },
    data() {
      return {
        addRoleRule:{
          roleName:[{required: true, message: '请输入角色名称', trigger: ['change','blur']}],
          remark:[{required: true, message: '请输入角色描述', trigger: ['change','blur']}]
        },
        addRoleForm:{
          roleName:'',
          remark:''
        },
        addRoleDialog:false,
        tableData: [],

        searchData: {
          roleName: '',
          userId: '',
          pageSize: 10,
          pageNum: 1
        },
        total: 0,
        userOption: [],
        activeRole:{},
        editType:false

      }
    },
    mounted() {
      this.getUserSelect()
      this.getTableData()
    },
    watch:{
      addRoleDialog(n){
        if(!n){
          this.$refs.addRoleForm.resetFields();
        }
      }
    },
    methods: {
      // 查看授权账号
      checkAccount(v){
        this.$router.push({
          name:'account',
          params:{id:v.id}
        })
      },
      // 查看或设置权限
      setUp(isCheck,v){
        v?this.$router.push({
          name:'permissionSetting',
          query:{
            id:v.id,
            menuIds:v.menuIds,
            isCheck
          }
        }):this.$router.push({
          name:'permissionSetting',
          query:{
            isCheck
          }
        })
      },
      // 删除角色
      deleteFun(v){
        this.activeRole = v
        this.$confirm('确定删除该角色吗？删除该角色当前所有关联此角色的账号将不能使用！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteRole()
        }).catch(() => {
                  
        });
      },
      deleteRole(){
        let params = {
          roleId:this.activeRole.id
        }
        roleManagementSerice.deleteRole(params).then(res=>{
          if(res.code == 1){
            this.$toast({
              type:'success',
              message:'删除成功！'
            })
            this.getTableData()
          }else{
            this.$toast({
              type:'error',
              message:'删除失败！'
            })
          }
        })
      },
      // 编辑角色
      editRole(){
        let params = {
          id:this.activeRole.id,
          ...this.addRoleForm
        }
        roleManagementSerice.addEditRole(params).then(res=>{
          if(res.code == 1){
            this.$toast({
              type:'success',
              message:'编辑成功！'
            })
            this.addRoleDialog = false
            this.getTableData()
          }else{
            this.$toast({
              type:'error',
              message:'编辑失败！'
            })
          }
        })
      },
      editFun(v){
        this.activeRole = v
        this.addRoleForm = {
          roleName:v.roleName,
          remark:v.remark
        }
        this.editType = true
        this.addRoleDialog = true
      },
      // 新建角色
      addFun(){
        this.$refs.addRoleForm.validate((valid) => {
          if (valid) {
            this.editType ? this.editRole() : this.addRole()
          } else {
            this.$toast({
              type:'error',
              message:'请填写必填参数！'
            })
            return false;
          }
        });
      },
      addRole(){
        let params = {
          ...this.addRoleForm
        }
        roleManagementSerice.addEditRole(params).then(res=>{
          if(res.code == 1){
            this.$toast({
              type:'success',
              message:'创建成功！'
            })
            this.addRoleDialog = false
            this.getTableData()
          }else{
            this.$toast({
              type:'error',
              message:'创建失败！'
            })
          }
        })
      },
      // 重置条件
      reset() {
        this.searchData = {
          roleName: '',
          userId: '',
          pageSize: 10,
          pageNum: 1
        }
        this.getTableData()
      },
      // 获取用户下拉框数据
      getUserSelect() {
        roleManagementSerice.getUserSelect().then(res => {
          if (res.code == 1) {
            this.userOption = res.data
          }
        })
      },
      otherPage(e) {
        this.searchData.pageNum = e.pageNum
        this.searchData.pageSize = e.pageSize
        this.getTableData()
      },
      getTableData() {
        let params = {
          ...this.searchData
        }
        roleManagementSerice.getRoleList(params).then(res => {
          if (res.code == 1 && res.data) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.tableData = []
            this.total = 0
          }
        })
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>